import Vue from 'vue'
import Router from 'vue-router'
import qs from 'qs'
import noPermission from '@/pages/no-permission/router'
import error from '@/pages/error/router'
import workshop from '@/pages/workshop/router'
import FeedbackCenter from '@/pages/feedback-center/routes/route'
import MessageCenter from '@/pages/message-center/routes/route'
import { matchNoRebuildAppRoute } from '@/config/apps'
import { matchMicroAppRoute, routerPath } from '@/micro-app'
import { useAppStore } from '@/store'
import { Omega } from '@/plugins/plugin-init-omega'
import { RouteScheduler } from '@/utils/tools'
Vue.use(Router)
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export const constantRoutes = [...MessageCenter, ...FeedbackCenter]

const routes = [
  {
    path: '/',
    redirect: '/home',
    hidden: true,
  },
  {
    path: '/workshop',
    redirect: '/home',
    hidden: true,
  },
  ...constantRoutes,
  ...noPermission,
  ...error,
  ...workshop,
  // 404
  // { path: '*', component: () => import('@/pages/error/pages/404'), hidden: true },
]
const createRouter = () =>
  new Router({
    base: process.env.VUE_APP_ROUTER_BASE,
    mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes,
    parseQuery(query) {
      return qs.parse(query)
    },
    stringifyQuery(query) {
      const result = qs.stringify(query)
      return result ? '?' + result : ''
    },
  })

const router = createRouter()

router.beforeEach(async (to, from, next) => {
  const appStore = useAppStore()
  // 记录主应用跳转子应用的起始时间
  if (!appStore.$state.loadTime.endTime) {
    appStore.$state.loadTime.startTime = new Date().getTime()
  }
  const hasHttpUrl = to?.meta?.httpUrl
  if (hasHttpUrl) {
    next()
    window.open(hasHttpUrl)
  }
  // 跳转到已改造微应用
  // 触发逻辑 基座通过router.push或子应用通过gtrRouter.push('/order/list')，需要增加prefix前缀
  // 通过路由跳转的真实path应为 /gtr_trans-mgr/order/list
  if (matchMicroAppRoute(to.path)) {
    console.info(`log ==》 跳转到已改造微应用`, to, from)
    next({
      path: routerPath(to.path),
      query: to.query,
      params: to.params,
    })
    return
  }
  // 跳转未改造应用
  if (matchNoRebuildAppRoute(to.path)) {
    console.info(`log ==》 跳转未改造应用`, to, from)
    next()
    window.open(to.fullPath)
    return
  }
  next()
})
router.afterEach((to, from, next) => {
  // 避免切换页面重定向时重复上报pageView，比如：/data-side -> /data-side/summary
  RouteScheduler(to.path, from.path, () => {
    Omega.sendPageView && Omega.sendPageView()
  })
})
// Detail see: https://github.com/vuejs/@/utils/route/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
